"use client";

import { useCurrentFrame, interpolate, useVideoConfig } from "remotion";

export default function ImageCarousel() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const slides = [
    { label: "Mountain", gradient: "linear-gradient(135deg, #3b82f6, #1d4ed8)" },
    { label: "Ocean", gradient: "linear-gradient(135deg, #4361ee, #7209b7)" },
    { label: "Forest", gradient: "linear-gradient(135deg, #a855f7, #7c3aed)" },
  ];

  const cycleLength = fps * 2;
  const progress = (frame % (cycleLength * slides.length)) / cycleLength;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1.5rem",
          position: "relative",
        }}
      >
        {slides.map((slide, i) => {
          const offset = i - progress;
          const translateX = offset * 280;
          const scale = interpolate(
            Math.abs(offset),
            [0, 1, 2],
            [1, 0.75, 0.55],
            { extrapolateRight: "clamp" }
          );
          const opacity = interpolate(
            Math.abs(offset),
            [0, 1, 2],
            [1, 0.5, 0.2],
            { extrapolateRight: "clamp" }
          );

          return (
            <div
              key={i}
              style={{
                position: "absolute",
                width: "240px",
                height: "320px",
                background: slide.gradient,
                borderRadius: "12px",
                transform: `translateX(${translateX}px) scale(${scale})`,
                opacity,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                padding: "1rem",
              }}
            >
              <span
                style={{
                  color: "white",
                  fontSize: "1rem",
                  fontWeight: 600,
                  fontFamily: "Inter, sans-serif",
                  textShadow: "0 1px 4px rgba(0,0,0,0.3)",
                }}
              >
                {slide.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
